import { useState } from 'react';
import FeatureNode from './FeatureNode';
import { sortByName, sortKeysAlphabetically } from '../../../../utils/sortingUtils';

/**
 * TreeNode - Represents a folder/namespace in the feature tree hierarchy
 */
export default function TreeNode({ node, path, isRoot = false, onRefresh, onRuleCellsChanged, onSearchFeature, onSearchValue, familyId }) {
    const [isCollapsed, setIsCollapsed] = useState(false);

    const childFolders = sortKeysAlphabetically(node.children || {});
    const childVars = sortByName(node.features || [], 'name');

    if (isRoot) {
        return (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
                {childFolders.map(name => (
                    <TreeNode key={name} node={node.children[name]} path={name} onRefresh={onRefresh} onRuleCellsChanged={onRuleCellsChanged} onSearchFeature={onSearchFeature} onSearchValue={onSearchValue} familyId={familyId} />
                ))}
                {childVars.map(v => (
                    <FeatureNode key={v.id} feature={v} onRefresh={onRefresh} onRuleCellsChanged={onRuleCellsChanged} onSearchFeature={onSearchFeature} onSearchValue={onSearchValue} familyId={familyId} />
                ))}
            </div>
        );
    }

    return (
        <div style={{ marginLeft: '1rem' }}>
            <div 
                onClick={() => setIsCollapsed(!isCollapsed)} 
                style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: '0.5rem', 
                    cursor: 'pointer', 
                    fontWeight: '600', 
                    color: 'var(--text-primary)',
                    padding: '0.25rem 0'
                }}
            >
                <i className={`fa-solid ${isCollapsed ? 'fa-chevron-right' : 'fa-chevron-down'}`} style={{ width: '0.7rem', fontSize: '0.7rem', color: 'var(--text-secondary)', flexShrink: 0 }}></i>
                <i className={`fa-regular ${isCollapsed ? 'fa-folder' : 'fa-folder-open'}`} style={{ color: 'var(--accent)' }}></i>
                <span>{node.name}</span>
            </div>
            
            {!isCollapsed && (
                <div style={{ borderLeft: '1px solid var(--border)', marginLeft: '5px', paddingLeft: '5px' }}>
                    {childFolders.map(name => (
                        <TreeNode key={name} node={node.children[name]} path={`${path}.${name}`} onRefresh={onRefresh} onRuleCellsChanged={onRuleCellsChanged} onSearchFeature={onSearchFeature} onSearchValue={onSearchValue} familyId={familyId} />
                    ))}
                    {childVars.map(v => (
                        <FeatureNode key={v.id} feature={v} onRefresh={onRefresh} onRuleCellsChanged={onRuleCellsChanged} onSearchFeature={onSearchFeature} onSearchValue={onSearchValue} familyId={familyId} />
                    ))}
                </div>
            )}
        </div>
    );
}
